<script>
  import Percent from '@/components/Percent';

  export default {
    components: {
      Percent,
    },

    props: {
      price: {
        type: String,
        required: true,
      },

      value: {
        type: String,
        required: true,
      },

      intervals: {
        type: Object,
        required: true,
      },
    },
  };
</script>

<template>
  <header class="transaction-chart-header card__body">
    <div class="transaction-chart-header__top">
      <h1 class="transaction-chart-header__title" v-text="price"></h1>

      <ul class="transaction-chart-header__options">
        <li
          :key="interval"
          class="transaction-chart-header__item"
          v-for="(_, interval) in intervals"
          >
          <a
            href="#"
            v-text="interval"
            class="transaction-chart-header__link"
            @click.prevent="$emit('input', interval)"
            :class="{ 'transaction-chart-header__link--active': value === interval}"
            >
            </a>
        </li>
      </ul>
    </div>

    <p class="transaction-chart-header__value">+R$634,00 <Percent class="transaction-chart-header__percent" :value="20" /></p>
  </header>
</template>

<style lang="scss">
  .transaction-chart-header {
    display: flex;
    color: #b2b8c5;
    flex-direction: column;

    &__title {
      color: #FFF;
      font-size: 32px;
      font-weight: 500;
      letter-spacing: 0.64px;
    }

    &__top {
      height: 38px;
      display: flex;
      margin-bottom: 8px;
      align-items: flex-start;
      justify-content: space-between;
    }

    &__options {
      display: flex;
      font-size: 13px;
      line-height: 0.92;
      letter-spacing: 0.26px;
    }

    &__item {
      &:not(:first-child) {
        margin-left: 8px;
      }
    }

    &__link {
      height: 24px;
      display: flex;
      padding: 0 10px;
      border-radius: 4px;
      align-items: center;
      justify-content: center;

      &:hover {
        background-color: rgba(#FFF, .1);
      }

      &--active {
        color: #273a59;
        font-weight: 500;
        background-color: #f6f7fa !important;
      }
    }

    &__value {
      display: flex;
      font-size: 13px;
      letter-spacing: 0.26px;
    }

    &__percent {
      margin-left: 44px;
    }
  }
</style>
